import * as React from 'react';

import * as styles from './styles.css';
import { Loader } from '../../../../common/components/Loader';

export const SearchResultsLoading = () => {
  return (
    <div className={styles['root']}>
      <Loader />
    </div>
  );
};
